import React, { FC, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { scrollToTop } from '../../utils'
import { fetchByDetailProject } from '../../store/slices/projectSlice'
import { NavLink, useParams } from 'react-router-dom'
import TopBanner from '../../components/TopBanner/TopBanner'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs'
import Loader from '../../components/Loader/Loader'
import { Helmet } from 'react-helmet-async'
import s from './DetailProject.module.scss'
import SwiperProject from '../Projects/SwiperProject/SwiperProject'
import BlockSlider from './BlockSlider/BlockSlider'
import ReactMarkdown from 'react-markdown'

const DetailProject: FC = () => {
    const { id, name } = useParams()
    const dispatch = useAppDispatch()
    const { detail, loading } = useAppSelector(state => state.projects)

    useEffect(() => {
        if (id) {
            scrollToTop()
            dispatch(fetchByDetailProject(Number(id)))
        }
    }, [dispatch, id])

    return (
        <>
            <Helmet>
                <meta property="og:title" content={`${name} | Проекты | Phoenix Programs`} />
                <meta property="og:description" content={`${name} - проект от Phoenix Programs`} />
                <meta name="twitter:title" content={`${name} | Проекты | Phoenix Programs`} />
                <meta name="twitter:description" content={`${name} - проект от Phoenix Programs`} />
                <link rel="canonical" href={`https://phoenix-programs.com/projects/${id}/${encodeURIComponent(name || '')}`} />
                <title>{`${name} | Проекты | Phoenix Programs`}</title>
            </Helmet>
            {loading && <Loader />}
            <TopBanner title={name} />
            <Breadcrumbs>
                <NavLink to={'/'}>Главная</NavLink>
                /
                <NavLink to={`/projects`}>Проекты</NavLink>
                /
                <span>{name}</span>
            </Breadcrumbs>

            {detail && (
                <>
                    {/* Hero Section with Gallery and Info */}
                    <section className={s.heroSection}>
                        <div className={`${s.container} container`}>
                        <div className={s.titleBlock}>
                                <h2 className={`${s.title} title`}><span />{detail?.title2}</h2>
                            </div>
                            <div className={s.heroGrid}>
                                <div className={s.gallery}>
                                    {detail?.preview_img && (
                                        <SwiperProject image={detail.preview_img} data={detail?.imagesData || []} />
                                    )}
                                </div>

                                <aside className={s.heroSidebar}>
                                    <div className={s.infoCard}>
                                        <div className={s.cardHeader}>
                                            <h3>Информация о пректе</h3>
                                        </div>
                                        
                                        <div className={s.infoItem}>
                                            <div className={s.infoValue}><ReactMarkdown>{detail?.project_info ?? ''}</ReactMarkdown></div>
                                        </div>
                                    </div>
                                </aside>
                            </div>
                        </div>
                    </section>

                    {/* Main Content Section */}
                    <section className={s.contentSection}>
                        <div className={`${s.container} container`}>
                        <div className={s.sectionContent}>
                        {detail?.description &&
                                    <>
                                        <h3 className={`${s.title} title`}>Описание проекта</h3>
                                        <div className={s.sectionDescription}><ReactMarkdown>{detail?.description ?? ''}</ReactMarkdown></div>
                                        </>
                                }
                                </div>
                            {detail?.sections && detail.sections.length > 0 && (
                                <div className={s.sectionsBlock}>
                                    {detail.sections.map((section) => (
                                        <div key={section.id} className={s.sectionItem}>
                                            {section.blocks && section.blocks.length > 0 && (
                                                <div className={s.blocksContainer}>
                                                    {section.blocks.map((block, blockIndex) => (
                                                        <div key={block.id} className={s.blockItem}>
                                                            <h1 className={`${s.titleBlock} title`}>{block.titleHero}</h1>
                                                            <div className={`${s.blockwrapper} ${blockIndex % 2 === 1 ? s.blockwrapperReversed : ''}`}> 
                                                            <div className={s.blockContent}>
                                                                {block.title && (
                                                                    <h3 className={s.blockTitle}>{block.title}</h3>
                                                                )}
                                                                {block.description && (
                                                                    <div className={s.blockDescription}><ReactMarkdown>{block.description}</ReactMarkdown></div>
                                                                )}
                                                            </div>
                                                            {block.images && block.images.length > 0 && (
                                                                <div className={s.blockSlider}>
                                                                    <BlockSlider images={block.images} />
                                                                </div>
                                                            )}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className={`${s.shapeRight}`} />
                        <span className={`${s.gradientLine} lineGradient bottom-line`} />
                    </section>
                </>
            )}
        </>
    )
}

export default DetailProject

